// No platformBrowserDynamic import here: the app bootstraps through bootstrapApplication below,
// and that symbol was never used. It is the JIT-compiler bridge, so importing it risks pulling
// @angular/compiler into a build that is AOT-compiled and does not need it.

// Swiper is registered lazily inside the meta-ads components that use it (the only
// feature with carousels), so its full ~element bundle stays out of the eager vendor.js.
import { APP_INITIALIZER, ErrorHandler, importProvidersFrom } from '@angular/core';
import { GlobalErrorHandlerService } from './app/core/shared-services/global-error-handler.service';
import { provideHttpClient } from '@angular/common/http';
// Async variant: the animations engine is fetched after bootstrap instead of sitting in the
// eager bundle. PageSpeed attributes 15.6 KiB to @angular/animations on /login with 8.7 KiB of it
// unused — a login form animates almost nothing. This is Angular's recommended default since v17.
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { AppRoutingModule } from './app/app-routing.module';
import { AppComponent } from './app/app.component';
import { MatNativeDateModule } from '@angular/material/core';
import { ShopifyEmbeddedService } from './app/core/shared-services/shopify-embedded.service';
// ngx-stripe is intentionally NOT provided here. Nothing in the app injects it — card
// entry goes through core/shared-services/stripe-service.ts, which calls loadStripe()
// from @stripe/stripe-js directly inside the lazy billing routes. Registering the
// provider only pulled ngx-stripe into the eager bundle on every page, including login.
// The package is still in package.json; only this unused registration was removed.

bootstrapApplication(AppComponent, {
    providers: [
        importProvidersFrom(BrowserModule, CommonModule, FormsModule, ReactiveFormsModule, RouterModule, AppRoutingModule, MatNativeDateModule),
        { provide: ErrorHandler, useClass: GlobalErrorHandlerService }, provideHttpClient(),
        {
          provide: APP_INITIALIZER,
          multi: true,
          deps: [ShopifyEmbeddedService],
          useFactory: (shopify: ShopifyEmbeddedService) => () => shopify.bootstrapInstallation(),
        },
        provideAnimationsAsync()
    ]
})
  .catch(err => console.error(err));


